import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-persona',
  templateUrl: './persona.component.html',
  styleUrls: ['./persona.component.scss']
})
export class PersonaComponent implements OnInit {
  @ViewChild('image_file', {static: false}) image_file: any; 
  @ViewChild('cloper',null) cloper;
  constructor(public authService: AuthService,
    public router: Router,
    private spinner: NgxSpinnerService
    ) { }

  ngOnInit() {
    this.ls_persona();   
  }
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }
  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  id_persona=0;
  id_perosna_box=0;
  nineb=0;
  per_box_=[];
  loading=false;
  _competences_9b=[];
  _goals_9b=[];
  cancel_nvoidp(){
    this.idp_v=true;
  }
  fn_nvo_goal_hk(){
    //this.metashk.push({id:1,hk:"ok",nombre:"12"})
    let postData = {
      id_role:this.id_role
    };
    console.log(postData);
    this.authService.service("/api/metas_hk",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);       
          this.metashk=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });    
  
    
    this.goal_v=true;
    this.bndgoal_hk=true;
    this.goal_e=false;
    this.goal_n=false;
  }
  id_role;
  rpt_hk(itm){
    console.log(itm)
    localStorage.setItem("t_hk","X");
    localStorage.setItem("nivel","1");
    localStorage.setItem("duenio_id",this.id_role);
    localStorage.setItem("duenio","");
    localStorage.setItem("fecha","");
    localStorage.setItem("superv","");
    localStorage.setItem("id_hk",itm.id_hk);
    this.router.navigate([]).then(result => {  window.open('./#/fmt_hk', '_blank'); }); 
  
  }
  date_goal:any;
  fn_edit_idp(itm){
    this.idp_v=false;
    this.idp_.id=itm.id;
    this.idp_.skill=itm.id_competencia;
    this.idp_.trainig=itm.actividades;
    try {
      this.idp_.fecha=itm.fecha.substring(0,10);  
    } catch (error) {
      this.idp_.fecha="";
    }
    
    this.idp_.costos=itm.costo;
    this.idp_.resultados=itm.resultado;
    this.idp_.estatus=itm.estado;
    this.idp_a=true;
  }
  fn_nvo_idp(){
    this.idp_.id=0;
    this.idp_.skill=0;
    this.idp_.trainig="";
    this.idp_.fecha="";
    this.idp_.costos=0;
    this.idp_.resultados="";
    this.idp_.estatus="A";
  
    this.idp_v=false;
    this.idp_a=false;
  }
  view_nineb(t){
    let postData = {
      id_persona:this.persona.id,
      id_evaluador:this.id_perosna_box
    };
    //console.log(postData);
   var a="";
    switch (t) {
      case 'C':
        a="/api/nine_box";
        break;
      case 'L':
        a="/api/nine_box_last";
          break;  
      default:
        break;
    }
    this.authService.service(a,postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          this.nineb=res[0].nineb;
          //this._eval_=res;
          this.loading=false;
          this._box.titulo="Nine Box ";
          this._box.contenido="Medición y evaluación de Competencias  "+
            " <br>Competences="+res[0].competence+""+
            " <br>Goals="+res[0].goals+"%";
          this._box.numero=1;
  
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
  
  }
  _box={
    titulo:"",
    contenido:"",
    numero:0
  };
  perbox(id){
    let postData = {
      id_persona:id
    };
    this.authService.service("/api/get_per_box",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);   
          this.per_box_=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
  
  }
  ver_9B(itm){
    this.id_persona=itm.id;  
    this.persona={
      id:itm.id, 
      id_role:0, 
      foto:itm.foto,
      fotopreview:"",
       nombre:itm.nombre,
       paterno:itm.apaterno,
       materno:itm.amaterno,
       email:itm.email,
       celular:itm.celular,
       telefono:itm.telefono,
       profesion:itm.profesion,
       fec_ingreso:itm.fec_ingreso,     
       chart:0
     };
    
     this.persona.id=itm.id;
     this.persona.nombre=itm.nombre;
     this.perbox(itm.id);
     this.nineb=0;
  }

  ver_role(itm){
    this.image_file.nativeElement.value = "";
    this.id_persona=itm.id;  
    this.persona={
      id:itm.id, 
      id_role:0, 
      foto:itm.foto,
      fotopreview:"https://hoshinup.garocedev.com:3007/"+ itm.foto,
       nombre:itm.nombre,
       paterno:itm.apaterno,
       email:itm.email,
       celular:itm.celular,
       telefono:itm.telefono,
       materno:itm.amaterno,
       profesion:itm.profesion,       
       fec_ingreso:(itm.ingreso).substring(0, 10),     
       chart:0
     };     
     this.bndedita_persona=0
  }
  
  VentanaFix=0;
  id_cliente=0;
  _persona;
  ls_persona(){
    this.spinner.show();
    let postData = {id_cliente:localStorage.getItem("id_cliente") } 
    console.log(postData);
    this.authService.service("/api/get_persona_cliente",postData)
    .then(
        data => { 
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this._persona=data;
          this._persona.sort((a,b) => a.nombre.localeCompare(b.nombre));
          this._personaaux=data;
          this.spinner.hide();
        },
        error => {
            this.spinner.hide();
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  eli_role(itm){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/eli_persona_cliente",postData)
    .then(
        data => {                
         swal.fire('ok', '', 'success');
         this.ls_persona();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)            
            swal.fire('¡API incorrecta!'+de, '', 'error');
        });
  }
  fn_perfil(itm){
    var css='{"id_persona":'+itm.id+',"id_role":'+0+'}'
    localStorage.setItem("perfil",css);    
    this.router.navigate(
      ['/perfil'],
      { queryParams: { caller: 'persona' } }
    );
  }
  bndedita_persona=0
  vf__persona(){
      this.image_file.nativeElement.value = "";

      this.URL = null;
      this.fileToUpload = null;

      this.bndedita_persona=1;
      this.persona={
        id:0, 
        id_role:0, 
        fotopreview:"",
        foto:"",
        nombre:"",
        paterno:"",
        materno:"",
        email:"",
        celular:"",
        telefono:"",
        profesion:"",
        fec_ingreso:"",     
        chart:0
     };
  }
  nva_persona(){   
    var sfec = "";
    try {
      var fec = new Date(this.persona.fec_ingreso + "T00:00:00");
      let dt = moment(new Date(fec), 'DD-MM-YYYY');
      sfec = dt.format('YYYY') + "-" + dt.format('MM') + "-" + dt.format('DD'); 
    } catch (error) {
      sfec = "";
    }
    if (this.valida_per2()==true){
      let postData = {
        id:0,
        nombre:this.persona.nombre,
        paterno:this.persona.paterno,
        materno:this.persona.materno,
        profesion:this.persona.profesion,
        email:this.persona.email==undefined?"":this.persona.email,
        celular:this.persona.celular==undefined?"":this.persona.celular,
        telefono:this.persona.telefono==undefined?"":this.persona.telefono,
        ingreso:sfec,
        foto:"",
        chart:0,
        id_cliente:localStorage.getItem("id_cliente") 
      } 
      this.hidCvePersona=this.persona.id;
      //console.log(postData);
      this.authService.service("/api/ins_persona_cliente",postData)
      .then(
          data => {   
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          var id = res[0][0].id;

          this.persona.id = id;
          this.hidCvePersona=this.persona.id;
            
          this.VentanaFix=0;         
          console.log("cloper")
          this.cloper.nativeElement.click();    
          console.log("cloper")  
          this.uploadFileToActivity();
           swal.fire('ok', '', 'success');
           this.ls_persona();
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              
              swal.fire('¡API incorrecta!'+de, '', 'error');
          });
    }
  }


  idp_area:boolean=false;
  feed_area:boolean=false;
  feed_v:boolean=true;
  feedb;
  feed={
    id:0,
    periodo:0,
    evaluacion:0,
    descripcion:""
  };
  a_feed:boolean=true;
  fn_edit_feed(itm){
    this.feed.id=itm.id;
    this.feed.descripcion=itm.descripcion;
    this.feed.evaluacion=itm.evaluacion;
    this.feed.periodo=itm.periodo;
    this.feed_v=false;
    this.a_feed=false;
  }
  fn_can_feedb(){
    this.feed_area=false;
    this.idp_area=true;
  }
  upd_feed(){
    let postData = {
      id_idp:this.feed.id,
      periodo:this.feed.periodo,
      evaluacion:this.feed.evaluacion,
      descripcion:this.feed.descripcion
    };
    
    this.authService.service("/api/upd_feed",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('Ok', '', 'success');
          this.ls_feed(this.hidcve_idp);
         this.ls_idp(this.hidCvePersona);
         this.feed_v=true; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! upd-feed', '', 'error');
        });    
  
  }
  ins_feed(){
    let postData = {
      id_idp:this.hidcve_idp,
      periodo:this.feed.periodo,
      evaluacion:this.feed.evaluacion,
      descripcion:this.feed.descripcion
    };
    //console.log(postData);
    this.authService.service("/api/ins_feed",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('Ok', '', 'success');
         this.ls_feed(this.hidcve_idp);
         this.ls_idp(this.hidCvePersona);
         this.feed_v=true; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! ins-feed', '', 'error');
        });    
  }
  fn_nvo_feedb(){
    this.feed_v=false;
    this.a_feed=true;
    this.hidcve_feed=0;
    this.feed.periodo=0;
    this.feed.evaluacion=0;
    this.feed.descripcion="";
  }
  fn_cancel_feedb(){
    this.feed_v=true;
  }
  
  ls_feed(id){
    let postData = {
      id_idp:id
    };
    this.authService.service("/api/get_feed",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.feedb=data;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });    
  }
  hidcve_feed;
  hidcve_idp;
  feed_name;
  fn_feed_idp(itm){
    //console.log(itm)
    this.feed_name=' { '+itm.competencia + ' \ ' + itm.periodo_+' }';
    this.hidcve_idp=itm.id;
    this.ls_feed(itm.id);
    this.feed_area=true;
    this.feed_v=true;
    this.idp_area=false;
  }
  idp;
  
  txteducation:string="";
  edu=[];
  txtanio_:Number=2021;
  p1;p2;p3;
c1;c2;c3;c4;c5;c6;c7;c8;c9;c10;
c11;c12;c13;c14;c15;c16;
  v_assesment(itm){
    //console.log(itm);
  this.persona.id=itm.id;
  this.persona.nombre=itm.nombre
  this.persona.paterno=itm.apaterno;
  this.persona.materno=itm.amaterno;
  this.p1="";this.p2="";this.p3="";         
  this.c1=0;this.c2=0;this.c3=0;this.c4=0;this.c5=0;this.c6=0;this.c7=0;this.c8=0;this.c9=0;this.c10=0;   
  this.c11=0;this.c12=0;this.c13=0;this.c14=0;this.c15=0;this.c16=0;   
  let postData = {  
    id_persona:itm.id
    
  }
  //console.log(postData);
  this.authService.service("/api/get_evaluacion_dpi",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                                
        this.loading=false;
        if(res.length>0){
          this.p1=res[0].p1;this.p2=res[0].p2;this.p3=res[0].p3;         
          this.c1=res[0].c1;this.c2=res[0].c2;this.c3=res[0].c3;this.c4=res[0].c4;this.c5=res[0].c5;this.c6=res[0].c6;this.c7=res[0].c7;this.c8=res[0].c8;this.c9=res[0].c9;this.c10=res[0].c10;   
          this.c11=res[0].c11;this.c12=res[0].c12;this.c13=res[0].c13;this.c14=res[0].c14;this.c15=res[0].c15;this.c16=res[0].c16;   
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta! get_evaluacion_dpi', '', 'error');
    }); 
  }
  gda_assesment(){  
    this.loading=true;
    let postData = {
      id_persona:this.persona.id,
      p1:this.p1,p2:this.p2, p3:this.p3,    
      c1:this.c1,c2:this.c2,c3:this.c3,c4:this.c4,c5:this.c5,c6:this.c6,c7:this.c7,c8:this.c8,c9:this.c9,c10:this.c10,
      c11:this.c11,c12:this.c12,c13:this.c13,c14:this.c14,c15:this.c15,c16:this.c16,
    } 
      //console.log(postData);
      this.authService.service("/api/gda_evaluacion_dpi",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                                
            this.loading=false;   
            swal.fire('ok', '', 'success');
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta! gda_evaluacion_dpi', '', 'error');
        });  
  }
  competence_v:boolean=true;
  competence_v_t:boolean=true;
  per_competencia_t;
  Comp_t;
  ls_competencia_trinity(){
    let postData = {}
    this.authService.service("/api/get_competencia_trinity",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
          //this.txbrlc="";
          //console.log(res);
          this.Comp_t=data;
          }        
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! trinity', '', 'error');
        });
  
  }
  fn_competencias_t(itm){
    this.persona.nombre=itm.nombre;
    this.competence_v_t=true;
    this.per_competencia_t=[];
    this.hidCvePersona=itm.id;
    this.ls_competencia_trinity();
    this.ls_percompetencias_t();
    //this.selgpoComp=0;
    //this.selComp=0;
    
  }
  comp_evaluacion;
comp_descripcion;
comp_evaluacion_t;
comp_descripcion_t;
txtgrado="";
nva_competencia_t(){
  this.competence_v_t=false;
  this.comp_ev=false;
}
comp_ev:boolean=false;
txtanio:any;
sel_t;
_busper;
can_pfpps(cve){
  let postData = {
    id_pfpps:cve
  }       
  //console.log(postData);
  this.authService.service("/api/del_pfpps",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('ok', '', 'success');
        let dat_={id:this.persona.id};
        this.pfp_ps(dat_);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
      });

}
per_competencia;
hidcompetenciaid;
txtbusper="";
cance_competencia_t(){
  this.competence_v_t=true;
}
_eval_;

year_comp=0;
v_eval(itm){
  this.loading=true
  let postData = {
    id_per_competencia:itm.id
  };
  
  
  
  this.authService.service("/api/get_evaluacion_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //console.log(res);
        this._eval_=res;
        this.loading=false;
        

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
          this.loading=false;
      });
}
bus_pfpps(){
  this._busper=[];
  
  let postData = {
    id_role:this.id_role,   
  persona:this.txtbusper,
  id_cliente:localStorage.getItem("id_cliente")
}
//console.log("bus_pfpps");
//console.log(postData);
  this.authService.service("/api/bus_persona",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //console.log(res);
        this._busper=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
      });

}
edt_percomp_t(itm){
  //console.log(itm);
  this.hidcompetenciaid=itm.id;
  this.comp_ev=true;
  this.competence_v_t=false;
  this.comp_evaluacion_t=itm.evaluacion; 
  this.comp_descripcion_t=itm.descripcion;
  this.year_comp=0;
}
nvo_pfpps(){
  this.v_pfpps=false;
}
ls_percompetencias(){
  let postData = {id_persona:this.hidCvePersona};
  this.authService.service("/api/get_per_competencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          this.per_competencia=data;
        }        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
evalua_competencia_t(){
  let postData = {
    id_per_competencia:this.hidcompetenciaid,
    id_evaluador:localStorage.getItem("usuario"),
    evaluacion:this.comp_evaluacion_t,
    descripcion:this.comp_descripcion_t
  };  
  //console.log(postData);
  this.authService.service("/api/eval_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias();
        this.competence_v=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
del_we(itm){
  let postData = {
    id:itm.id
  }
  this.authService.service("/api/del_we",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('¡Ok!', '', 'success');
        this.get_we(this.hidCvePersona); 
                  
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
      });

}
gda_pfpps(itm,t){
  //console.log("gda_pfpps");
  //console.log(itm)
  let postData = {
    tpo:t,
    id_persona:itm.id,
    id_role2:itm.id_role,
    id_role:this.id_role
  }
  //console.log
  //console.log(postData);
  this.authService.service("/api/gda_pfpps",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this._busper=res;
        let dat_={id:this.persona.id};
        this.pfp_ps(dat_);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
      });
}
del_educacion(itm){
  let postData = {
    id:itm.id
  }
  this.loading=true 
  this.authService.service("/api/del_educacion",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        
          this.get_education(this.hidCvePersona); 
          this.loading=false;   
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
          this.loading=false;
      });

}
ins_competencia_t(){
  let postData = {
    id_persona:this.hidCvePersona,
    id_competencia:this.sel_t,
    id_role_card:0
  };
  if(this.sel_t==0)return;
  this.authService.service("/api/ins_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias_t();
        this.competence_v_t=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
del_percomp_t(id){
  if (!confirm("The data will be saved!"))return;
  let postData = {id_:id};
  this.authService.service("/api/del_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.ls_percompetencias_t();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });

}
gda_we(){
  //console.log(this.hidCvePersona);
  let postData = {
    anio:Number(this.txtanio),
    id_persona:this.hidCvePersona,
    descripcion:this.we.descripcion,
    empresa:this.we.empresa
  } 
  this.loading=true;
  //console.log(postData);
  this.authService.service("/api/gda_we",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
                   
        } 
        this.get_we(this.hidCvePersona); 
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
          this.loading=false;
      });
}
gda_education(){
  this.loading=true;
  //console.log(this.txteducation);
  if(this.txteducation==null && this.txteducation==undefined)return;
  let postData = {
    id_persona:this.hidCvePersona,
    anio:Number(this.txtanio_),
    descripcion:this.txteducation,
    escuela:this.txtgrado
  } 
  //console.log(postData);
  this.authService.service("/api/gda_educacion",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
                   
        } 
        this.txteducation="";
        this.txtgrado="";
        this.get_education(this.hidCvePersona); 
        this.loading=false 
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false 
          swal.fire('¡API incorrecta!', '', 'error');
      });
}
fmt_assesment(){
  localStorage.setItem("id_persona",this.persona.id.toString());  
  localStorage.setItem("tpo","X");  
  console.log(this.persona);
  localStorage.setItem("nombre",this.persona.nombre+" "+this.persona.paterno+" "+this.persona.materno)  
  this.router.navigate([]).then(result => {  window.open('./assesment', '_blank'); });          
}
  pfpps;
  v_pfpps:boolean=true;
  pfp_ps(itm){    
    //console.log(itm);    
    this.v_pfpps=true;
    let postData = {
      id_persona:itm.id,
    }    
    //console.log(postData);
    this.authService.service("/api/get_pfpps",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.pfpps=res;
          //console.log(res);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });

  }
  load_persona(itm){
    //console.log(itm);
    this.persona.id=itm.id;
    
    this.persona.foto=itm.foto;
    this.persona.nombre=itm.nombre;
    this.persona.paterno=itm.apaterno;
    this.persona.materno=itm.amaterno;
    this.persona.profesion=itm.profesion;
    //this.persona.role_id=itm.role;
  }
  ls_pfpps(itm){
    this.persona.nombre=itm.nombre;
    this.load_persona(itm);
    this.id_role=itm.id_role; 
    this.pfp_ps(itm);
  }
  ls_percompetencias_t(){
    let postData = {id_persona:this.hidCvePersona};
    this.authService.service("/api/get_per_competencia_trinity",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.per_competencia_t=data;
          }        
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
        });
  }
  get_education(cve){
    let postData = {
      id_persona:this.hidCvePersona,
    } 
    //console.log(postData);
    this.authService.service("/api/get_educacion",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.edu=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  fn_edu(itm){
    this.persona.nombre=itm.nombre;
    this.txteducation=""
    this.txtanio_=0;
    this.edu=[];
    this.hidCvePersona=itm.id;
    this.get_education(itm.id);
  }
  we_=[];
  get_we(cve){
    this.hidCvePersona=cve;
    let postData = {
      id_persona:cve
    }
    this.authService.service("/api/get_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                       
          this.we_=data;          
                   
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });

  }
  we={
    anio:0,
    empresa:"",
    descripcion:""
  };
  fn_we(itm){
    this.persona.nombre=itm.nombre;
    this.we.empresa="";
    this.we.anio=null;
    this.we.descripcion="";
    this.hidCvePersona=itm.id;
    this.get_we(itm.id);
  }
  fn_goals(itm){
    this.id_role=itm.id_role;
    this.persona.nombre=itm.nombre;
    this.goal_e=false;
    this.goal_v=false;
    console.log(itm);
    this.hidCvePersona=itm.id;
    this.txtgoals="";
    this.ls_goals();
  }
  fn_idp(itm){
    this.hidCvePersona=itm.id; 
    this.persona.nombre=itm.nombre;
    //console.log(itm);
    this.idp=[];
    this.ls_idp(itm.id);  
    this.ls_competencias();
    this.idp_v=true;
    this.feed_area=false;
   this.idp_area=true;
  }
  idp_=
  {
    id:0,
    skill:0,
    trainig:"",
    fecha:"",
    costos:0,
    resultados:"",
    estatus:'A'
  };
  lista_gaol(){
    this.goal_v=false;
    this.goal_e=false;
  }
  gdahk_goals(){
    let postData = {
      id_goal:this.hidid_goal,
      evaluacion:this.ev_goals,
      id_evaluador:localStorage.getItem("usuario"),
      
      descripcion:this.txtdescgoals
    };
    //console.log(postData);
    this.authService.service("/api/ins_evalgoalshk",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('Ok', '', 'success');
          this.ls_goals();        
          this.goal_v=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });    
  }
  ls_goals_hk(){  
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    }       
    this.authService.service("/api/get_org",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.org=data;
          var bnd=0;
          for(var i=0;i<this.org.length;i++){              
            if(this.org[i].director==1){
              if(bnd==0){               
                this.duenio_id_n1= this.org[i].id_role;  
                bnd=1;
              }
            }              
          }  
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });                
        let postData2 = {
          id_hk:this.proyecto,
          usu:this.id_role,
          id_responsable:this.id_role
        }      
        var api="/api/despliegue_usu";
        if(this.duenio_id_n1==this.id_role){        
          api="/api/despliegue_resp";
        }
        this.authService.service(api,postData)
        .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);  
            this.despliegue_=res;          
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡Información incorrecta!', '', 'error');
          });
    
    
  
  }
  proyecto;
  duenio_id_n1=0;
  duenio_id_nr="";
  org;

id_evlhk=0;
  despliegue_=[];
  fn_nvo_goal(){
    this.goal_v=true;
    this.bndgoal_hk=false;
    this.goal_n=true;
    this.id_evlhk=0;
  }
_evalgoalhk=[];
del_evaluate_goal(itm){
  if(confirm("Confirm to delete this row?")==false)return;
  let postData = {
    id:itm.id   
  }
  
  this.authService.service("/api/del_goal",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);              
      this.ls_goals();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('API incorrecta!', '', 'error');
    });  
}
ins_goal_hk(itm){
  this.id_evlhk=itm.id;
  this.txtgoals="[HK]-"+itm.nombre;
  this.bndgoal_hk=false;
  this.goal_n=true;
}
ins_goals(){
  let postData = {
    id_persona:this.hidCvePersona,
    goal:this.txtgoals,
    fecha:this.date_goal,
    id_hk:this.id_evlhk
  };
  this.authService.service("/api/ins_goals",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('Ok', '', 'success');
        this.ls_goals();        
        this.goal_v=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });    
}
evaluate_goal(itm){
  
  this.hidid_goal=itm.id;
  this.txtdescgoals="";
  this.ev_goals=0;
  /*
  this.txtdescgoals=itm.descripcion;
  this.ev_goals=itm.evaluacion;
  */
  this.goal_v=true;
  this.goal_e=true;
  this.goal_n=false;
  this.bndgoal_hk=false;
}
insall_goal_hk(){
  let postData = {
    id_persona:this.id_role,
    
  };
  console.log(postData);
  this.authService.service("/api/ins_allgoals",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('Ok', '', 'success');
        this.ls_goals();        
        this.goal_v=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  

}
  evalgoalhk(itm){
    let postData = {  
      id_goal:itm.id
    };
    console.log("evalgoalhk");
    console.log(postData);
    this.authService.service("/api/get_evalgoalshk",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //swal.fire('Ok', '', 'success');
          console.log(this._evalgoalhk);
          this._evalgoalhk=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });    
  
  }
  ls_goals(){
    let postData = {
      id_persona:this.hidCvePersona
    };
    //console.log(postData);
    this.authService.service("/api/get_goals",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          
          this.goals=data;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! goal', '', 'error');
        });    
  }
  upd_goals(){
    let postData = {
      id_goal:this.hidid_goal,
      goal:this.txtgoals,
      evaluacion:this.ev_goals,
      descripcion:this.txtdescgoals
    };
    this.authService.service("/api/upd_goals",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('Ok', '', 'success');
          this.ls_goals();        
          this.goal_v=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });    
  }
  metashk=[];
  idp_a:boolean=true;
  fn_updidp(){
  if(this.valida_idp()==false)return;
  let postData = {
    id:this.idp_.id,
    id_competencia:this.idp_.skill,
    actividades:this.idp_.trainig,
    fecha:this.idp_.fecha,
    costo:this.idp_.costos,
    resultado:this.idp_.resultados,
    estado:this.idp_.estatus   
  };
  this.authService.service("/api/upd_idp",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.idp_v=true;
        swal.fire('Ok', '', 'success');
        this.ls_idp(this.hidCvePersona);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  
  }
  fn_insidp(){
    if(this.valida_idp()==false)return;
    let postData = {
        id:this.idp_.id,
        id_persona:this.hidCvePersona,
        id_competencia:this.idp_.skill,
        actividades:this.idp_.trainig,
        fecha:this.idp_.fecha,
        costo:this.idp_.costos,
        resultado:this.idp_.resultados,
        estado:this.idp_.estatus    
    };
    this.authService.service("/api/ins_idp",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.idp_v=true;        
          this.ls_idp(this.hidCvePersona);
          swal.fire('Ok', '', 'success');
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });  
  
  }
  goals;
  
  txtgoals:any;
  txtdescgoals:any;
  goal_n:boolean=false;
  goal_v:boolean=false;
  bndgoal_hk:boolean=false;
  hidid_goal:number=0;
goal_e:boolean=false;
ev_goals:number=0;
  competencias=[];
  competencias_=[];
  idp_v:boolean=true;
  ls_competencias(){
    let postData = {};
    this.authService.service("/api/get_allcompetencias",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.competencias=data;
            this.competencias_=data;
            //console.log(res);          
          }
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });  
  }
  ls_idp(id_){
    let postData = {id_persona:id_}
    this.authService.service("/api/get_idp",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.idp=data;
            //console.log(res);          
          }
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });  
  
  }
  valida_idp(){
    return true;
  }

  _show(c){
    switch (c) {
      case 'IDP':this.container_p=2;this.idp_area=true;break;
      case 'GOALS':this.container_p=3;break;
      case 'WE':this.container_p=4;break;
      case 'PC':this.container_p=5;break;
      case 'Edu':this.container_p=6;break;
      case 'PFP':this.container_p=7;break;
      case 'PS':this.container_p=8;break;
      case 'AS':this.container_p=9;break;
      case 'FMT':this.container_p=10;break;    
      default:
        break;
    }
  }
  nombre="";
  paterno="";
  materno="";
  limpia_nombre(){ 
    this.persona.nombre="";
    this.persona.paterno="";
    this.persona.materno="";
    this._persona=this._personaaux;
  }
  _personaaux;
  bus_persona(){
    console.log("ok")
    var _per=[];
    //console.log(this.persona);
    for(var i=0;i<this._personaaux.length;i++){
      console.log(this._personaaux[i])
      if( this._personaaux[i].nombre.toLowerCase().includes(this.persona.nombre.toLowerCase()) && 
          this._personaaux[i].apaterno.toLowerCase().includes(this.persona.paterno.toLowerCase()) &&
          this._personaaux[i].amaterno.toLowerCase().includes(this.persona.materno.toLowerCase())   ){
            _per.push(this._personaaux[i]);
      }      
    }
    this._persona=_per;
  }
  role_name="";
  valida_per2(){
    if(this.persona.nombre==undefined){
      swal.fire('Name Incomplete!', '', 'error');
      return false;
    }
    if(this.persona.paterno==undefined && this.persona.paterno==""){
      swal.fire('Fathers Surname Incomplete!', '', 'error');
      return false;
    }    
    
    
    return true;
  }
 
  uploadFileToActivity(){
    //console.log("upload");
     
      if (this.fileToUpload) {
        console.log ("Si")
        var reader = new FileReader();
        
        reader.readAsDataURL(this.fileToUpload); // read file as data url
        const file = this.fileToUpload;
        
        reader.onload = (event) => { 
          this.URL = reader.result;
    
          var tmpDate = new Date();     //  Wed Oct 16 2013 12:37:29 GMT+0200
          var now = tmpDate.getTime();
          let data: any = {
            cveentevt: 1,
            name: now + '.' + this.ext_(file.type),
            firma: this.URL,
            idx: 1,
            id_persona:this.hidCvePersona                            
          }
          
          
          this.persona.foto=data.name;
          data.TYPE = 'pdf';
          data.FILENAME = 'files/' + now + '.pdf',
          
           //this.loading =true;
          console.log("data",data);
            
            this.authService.upImagen(data).then(res => {
              var mm = JSON.stringify(res)
              var dd = JSON.parse(mm)
              this.msg_foto="<span class=green>✔</span> ";
              //console.log("guardado");
              //this.img1.id = res[0].cveevtanx;
              //this.img1.url = this.urlwebimg +  now + ".png";
              this.txt_fot=  now + ".png" 
              //this.loading =false;
                //this.PDF =  dd.detailed_message            
              //swal.fire('DOCUMENTO SE GUARDO EXITOSAMENTE','DOCUMENTO SE GUARDO EXITOSAMENTE','success')
                // console.log(dd.detailed_message)              
              for(var i=0;this._persona.length;i++){
                if(this._persona[i].id==this.hidCvePersona){
                  this._persona[i].foto=data.name;
                }
              }
            },error => {
              this.msg_foto=" <span style=color:red;>X error</span> ";
            }
            )
          }
        }
    }
    hidCvePersona;
    txt_fot;
  gda_persona(){
    var sfec = "";
    try {
      var fec = new Date(this.persona.fec_ingreso + "T00:00:00");
      let dt = moment(new Date(fec), 'DD-MM-YYYY');
      sfec = dt.format('YYYY') + "-" + dt.format('MM') + "-" + dt.format('DD'); 
    } catch (error) {
      sfec = "";
    }    
    if (this.valida_per2()==true){
      let postData = {
        id:this.persona.id,
        nombre:this.persona.nombre,
        paterno:this.persona.paterno,
        materno:this.persona.materno,
        profesion:this.persona.profesion,
        email:this.persona.email==undefined?"":this.persona.email,
        celular:this.persona.celular==undefined?"":this.persona.celular,
        telefono:this.persona.telefono==undefined?"":this.persona.telefono,
        ingreso:sfec,
        foto:this.persona.foto,
        chart:Number(this.persona.chart),
      } 
      this.hidCvePersona=this.persona.id;
      console.log(postData);
      this.authService.service("/api/upd_persona",postData)
      .then(
          data => {
            console.log("cloper")
            this.cloper.nativeElement.click();    
            console.log("cloper")
            this.uploadFileToActivity();
            swal.fire('ok', '', 'success');
           this.ls_persona();
           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              
              swal.fire('¡API incorrecta!'+de, '', 'error');
          });
    }
  }
  _regresa(){
    this.VentanaFix=0;
  }
  public URL:any;
public evento:any;
public img1:any;
public urlwebimg:any;
public msg_foto:any;
 ext_(f:any) {
   //console.log(f);
   var c:string[]=f.split("/");
  return c[(c.length-1)]; 
}
fileToUpload: File = null;
onSelectFile(event,idx) {
  //console.log(event);
  this.URL = event.target.files;
  this.fileToUpload = event.target.files[0];

  ////////////////////////////////////////////////////////////////////
  var reader = new FileReader();
  URL = event.target.files;      
  reader.readAsDataURL(event.target.files[0]); 
  reader.onload = (event) => {  
    let URL: any = reader.result;
    this.persona.fotopreview = URL;     
  }

}
  container_p=0;
  persona={
    id:0, 
    id_role:0, 
    fotopreview:"",
    foto:"",
     nombre:"",
     paterno:"",
     materno:"",
     email:"",
     celular:"",
     telefono:"",
     profesion:"",
     fec_ingreso:"",     
     chart:0
   };

}
